import { createActions } from 'redux-actions';

import { Ingestion } from '@models/Ingestion';
import { GetAllIngestionParams, CreateIngestionParams } from '@apis/IngestionApi';
import { Pagination } from '@models/Pagination';

export type State = {
  ingestions?: Ingestion[] | null;
  pagination?: Pagination;
  isLoading?: boolean;
};

export type IngestionsFetchPayload = GetAllIngestionParams;
export type IngestionCreatePayload = CreateIngestionParams;
export type StateUpdatePayload = Partial<State>;

export const {
  ingestionsFetch,
  ingestionCreate,
  stateUpdate,
  stateClear,
} = createActions(
  'INGESTIONS_FETCH',
  'INGESTION_CREATE',
  'STATE_UPDATE',
  'STATE_CLEAR',
  {
    prefix: 'FEATURE_INGESTION',
  },
);
